<mat-icon
  class="mng-icon"
  [color]="getMatIconColor(color())"
  [inline]="inline()"
  [style.font-size.px]="fontSize()"
  [style.width.px]="fontSize()"
  [style.height.px]="fontSize()"
  [style.min-height.px]="fontSize()"
  [style.line-height.px]="fontSize()"
  [style.--mat-icon-button-icon-size.px]="fontSize()"
  [svgIcon]="iconName()"
/>
